import styled from '@emotion/styled'

export const Container = styled.div`
  max-width: 500px;
  margin: 3rem auto;
  padding: 2rem;
  text-align: center;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.08);
`

export const IconWrapper = styled.div`
  width: 80px;
  height: 80px;
  margin: 0 auto 1.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f44336;
  border-radius: 50%;
  color: white;

  svg {
    width: 48px;
    height: 48px;
  }
`

export const Title = styled.h2`
  font-size: 1.8rem;
  color: #d32f2f;
  margin-bottom: 1rem;
  font-weight: 600;
`

export const Message = styled.p`
  font-size: 1.1rem;
  color: #555;
  line-height: 1.6;
  margin: 0 auto 2rem;
  max-width: 80%;
`

export const Meta = styled.p`
  font-size: 0.85rem;
  color: #999;
  word-break: break-all;
  margin-bottom: 1.5rem;
`

export const RetryButton = styled.button`
  background-color: #d32f2f;
  color: white;
  border: none;
  padding: 0.8rem 1.5rem;
  font-size: 1rem;
  border-radius: 6px;
  cursor: pointer;
  transition: background-color 0.3s;
  margin-right: 1rem;

  &:hover {
    background-color: #b71c1c;
  }
`

export const ContactLink = styled.a`
  color: #555;
  text-decoration: none;
  border: 1px solid #ddd;
  padding: 0.8rem 1.5rem;
  border-radius: 6px;
  transition: all 0.3s;

  &:hover {
    background-color: #f5f5f5;
  }
`
